export const checkReverse = (data) => {
	if (data?.reverse) {
		return data?.quantity - data?.reverse_quantity;
	}
	return data?.quantity;
};
